import { Container } from './WrapperStyles';

const Wrapper = ({ children }) => {
    return <Container>{children}</Container>;
};

export default Wrapper;
